import React from 'react';

import { Course, useViewerCoursesStatusQuery } from '@edx/graphql/generated';
import { MediaGrid } from '@edx/components/media-grid';

type Props = {
  courses: Course[];
};

export const CoursesGrid: React.FC<Props> = ({ courses }) => {
  const { data } = useViewerCoursesStatusQuery();

  const items = React.useMemo(
    () =>
      ((data?.courses || courses) as Course[]).map(
        ({ name, resourcePath, videosCount, description, status, imageUrl, viewerCompletionPercentage }: Course) => ({
          title: name,
          subtitle: `${videosCount} videos`,
          resourcePath,
          description,
          status,
          imageUrl: imageUrl as string,
          viewerCompletionPercentage,
        })
      ),
    [courses, data?.courses]
  );

  return <MediaGrid items={items} className="mt-15" />;
};
